import { Vibration } from "react-native"
import { presets } from "../config/hapticFeedback"

type VibrationPreset = keyof typeof presets

export const vibrate = (preset: VibrationPreset) => {
    Vibration.vibrate(presets[preset])
}
